import React, { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from "react";
import teliJson from "../assets/teli.json";  // file JSON con i dati dei teli
import { NullableString } from "../../../../core/common_types";
import { Telo } from "../../../../models/pergola_configuration";
import * as THREE from 'three';

type TeliContextData = {
  getTeloName: (code: string | null | undefined) => string;
  getTeloImgPreview: (code: NullableString) => Promise<HTMLImageElement | undefined>;
  createTextureTeli: (code: NullableString) => Promise<THREE.Texture | undefined>;
  list: Telo[];
};

const TeliContext = createContext<TeliContextData | null>(null);

const TeliProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [teliData, setTeliData] = useState<Telo[]>([]);

  useEffect(() => {
    setTeliData(teliJson);
  }, []);

  const getTeloName = (code: string | null | undefined): string => {
    if (!code) return "";
    const telo = teliData.find(t => t.code === code);
    return telo ? telo.code : ""; 
  };
const createTextureTeli = async (code: NullableString): Promise<THREE.Texture | undefined> => {
  if (!code) return undefined;

  const telo = teliData.find(t => t.code === code);
  if (!telo?.img) return undefined;

  return new Promise((resolve) => {
    const loader = new THREE.TextureLoader();
    loader.crossOrigin = "anonymous";
    if (!telo?.img) return undefined;
    loader.load(
      telo.img,
      (texture) => {
        // Se vuoi forzare lo sRGB (dipende dalla tua versione di three.js)
        (texture as any).encoding = THREE.SRGBColorSpace;
        texture.flipY = false;
        resolve(texture);
      },
      undefined,
      () => resolve(undefined)
    );
  });
};



  const getTeloImgPreview = (code: NullableString): Promise<HTMLImageElement | undefined> => {
    return new Promise(resolve => {
      if (!code) return resolve(undefined);

      const telo = teliData.find(t => t.code === code);
      if (!telo || !telo.img) return resolve(undefined);

      const img = new Image(800, 800);
      img.crossOrigin = "anonymous";
      img.referrerPolicy = "origin";
      img.onload = () => resolve(img);
      img.src = telo.img;
    });
  };

  return (
    <TeliContext.Provider value={{ getTeloName, getTeloImgPreview,createTextureTeli, list: teliData }}>
      {children}
    </TeliContext.Provider>
  );
};

export default TeliProvider;

export const useTeli = () => {
  const context = useContext(TeliContext);
  if (!context) {
    throw new Error("useTeli must be used within a TeliProvider");
  }
  return context;
};
